import { render, staticRenderFns } from "./orderClearDialog.vue?vue&type=template&id=23dd4ec8&scoped=true&"
import script from "./orderClearDialog.vue?vue&type=script&lang=js&"
export * from "./orderClearDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderClearDialog.vue?vue&type=style&index=0&id=23dd4ec8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dd4ec8",
  null
  
)

export default component.exports